import React, { useMemo } from 'react';

import styled, { css } from 'styled-components/macro';
import { useSortableData } from 'features/shared/hooks/useSortableData';

interface Props {
  isRegion: boolean;
}
const Wrap = styled.div``;

const Name = styled.div`
  width: 150px;
  color: rgba(9, 21, 38, 0.6);
  font-size: 14px;
  line-height: 20px;
  padding-right: 4px;
`;
const Persent = styled.div`
  flex: 1 0 auto;
  display: flex;
  margin-right: 42px;
`;
const Progress = styled.div`
  height: 20px;
  min-width: 1px;
`;
const ProgressLabel = styled.div`
  line-height: 20px;
  margin-left: 4px;
  color: rgba(9, 21, 38, 0.6);
  font-size: 14px;
  line-height: 20px;
  width: 0px;
`;

const Row = styled.div<{ isCurrent?: boolean }>`
  display: flex;
  align-items: center;
  &:not(:last-child) {
    margin-bottom: 16px;
  }

  ${(props) =>
    props.isCurrent &&
    css`
      padding: 8px;
      border: 1px solid rgba(9, 21, 38, 0.15);
      box-shadow: 0px 4px 8px rgba(57, 78, 127, 0.2);
      border-radius: 7px;
      background: #ffffff;
      margin-left: -8px;
      margin-right: -8px;
      ${Name} {
        font-weight: 700;
      }
    `}
`;
const Hr = styled.div`
  background: rgba(9, 21, 38, 0.6);
  width: 100%;
  height: 1px;
  margin: 10px 0 24px;
`;

const HeaderTitle = styled.span`
  color: rgba(9, 21, 38, 0.6);
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
`;

export const ChartRow = (props: { title: string; value: number; color: string; isCurrent: boolean }) => {
  return (
    <Row isCurrent={props.isCurrent}>
      <Name>{props.title}</Name>
      <Persent>
        <Progress style={{ background: props.color, width: `${props.value}%` }}></Progress>
        <ProgressLabel>{props.value}%</ProgressLabel>
      </Persent>
    </Row>
  );
};

const Chart = (props: {
  header: string;
  rows: { title: string; value: number; isCurrent: boolean }[];
  color: string;
}) => {
  const rows = props.rows.map((el) => ({ ...el, color: props.color }));
  const items = rows;

  return (
    <Wrap>
      <Row style={{ marginBottom: 0 }} isCurrent={false}>
        <Name>
          <HeaderTitle>Лидеры</HeaderTitle>
        </Name>
        <Persent style={{ margin: 0 }}>
          <HeaderTitle>{props.header}</HeaderTitle>
        </Persent>
      </Row>
      <Hr />
      {items.map((el, i) => (
        <ChartRow key={i + el.title + el.value} {...el} />
      ))}
    </Wrap>
  );
};

export default Chart;
